import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

// core components
import Button from "components/CustomButtons/Button.js";

import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
import 'assets/scss/material-dashboard-pro-react/_fileupload.scss'

export default function ImageUpload(props) {

  const {fileSelection} = props;
  console.log("DO I GOT THE IMAGE: ", props.imageUrl)

  const [file, setFile] = React.useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    props.imageUrl
    // props.imageUrl ? props.imageUrl : (props.avatar ? defaultAvatar : defaultImage)
  );
  const imageToUse = imagePreviewUrl ? imagePreviewUrl : (props.imageUrl ? props.imageUrl : defaultImage)
  let fileInput = React.createRef();
  const handleImageChange = e => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      setFile(file);
      setImagePreviewUrl(reader.result);
      console.log("selected file 1")
      if (fileSelection) {
        console.log("selected file 2")
        fileSelection(file);
      }
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };
  // eslint-disable-next-line
  const handleSubmit = e => {
    e.preventDefault();
    console.log("HANDLE IMAGE SUBMIT")
    // file is the file/image uploaded
    // in this function you can save the image (file) on form submit
    // you have to call it yourself
  };
  const handleClick = () => {
    fileInput.current.click();
  };
  const handleRemove = () => {
    setFile(null);
    setImagePreviewUrl(props.avatar ? defaultAvatar : defaultImage);
    fileInput.current.value = null;
  };
  let { avatar, changeButtonProps, removeButtonProps } = props;//addButtonProps
  return (
    <div className="fileinput text-center">
      <input type="file" accept="image/png, image/jpeg" onChange={handleImageChange} ref={fileInput} />
      <Button className='p-0 m-0' onClick={() => handleClick()}>
        <div className={"thumbnail" + (avatar ? " img-circle" : "")}>
            {/* <img src={imagePreviewUrl ?? props.imageUrl} alt="..." /> */}
            <img src={imageToUse} />
        </div>
      </Button>
      <div>
        {file !== null && (
          <span>
            <Button {...changeButtonProps} onClick={() => handleClick()}>
              Change
            </Button>
            {avatar ? <br /> : null}
            <Button {...removeButtonProps} onClick={() => handleRemove()}>
              <i className="fas fa-times" /> Remove
            </Button>
          </span>
        )}
        {/* {file === null ? (
          <Button {...addButtonProps} onClick={() => handleClick()}>
            {avatar ? "Add Photo" : "Select image"}
          </Button>
        ) : (
          <span>
            <Button {...changeButtonProps} onClick={() => handleClick()}>
              Change
            </Button>
            {avatar ? <br /> : null}
            <Button {...removeButtonProps} onClick={() => handleRemove()}>
              <i className="fas fa-times" /> Remove
            </Button>
          </span>
        )} */}
      </div>
    </div>
  );
}

ImageUpload.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  imageUrl: PropTypes.string
};
